(function(angular) {
    /**
     * @ngdoc component
     * @name GridTableConfigController
     * @description List table component controller
     */
    class GridEditableCellController {
        static get $inject() {
            return ['$injector'];
        }

        constructor() {
            this.newCellValue = '';
        }

        $onInit() {
            this.newCellValue = this.row.viewDatasetRow.values[this.cellIndex].value;
        }

        /**
         * @ngdoc method
         * @name GridEditableCellController#triggerEditCellComplete
         * @description Informs the parent component when a grid-cell value editing complete, if the value changed
         */
        triggerEditCellComplete() {
            const oldCellValue = this.row.viewDatasetRow.values[this.cellIndex].value;

            if (oldCellValue === this.newCellValue) {
                this.triggerAbortEditingCell();
                return;
            }
            this.onEditCellComplete({
                oldCellValue: oldCellValue,
                newCellValue: this.newCellValue,
                rowKey: this.row.viewDatasetRow.key,
                isGroupRow: this.row.isGroupRow
            });
        }

        /**
         * @ngdoc method
         * @name GridEditableCellController#triggerAbortEditingCell
         * @description Informs the parent component when a grid-cell value editing aborted, by clicking away,
         * pressing esc
         */
        triggerAbortEditingCell() {
            this.onAbortEditingCell();
        }

        /**
         * @ngdoc method
         * @name GridEditableCellController#handleKeyUp
         * @description watches the grid cell input for enter to complete the editing, or esc to abort the editing
         */
        handleKeyUp($event) {
            switch ($event.keyCode) {
                case 27: // escape
                    this.triggerAbortEditingCell();
                    break;
                case 13: // enter
                    this.triggerEditCellComplete();
                    break;
            }
        }
    }

    angular.module('wtUi.wtGridTable').component('gridEditableCell', {
        controller: GridEditableCellController,
        templateUrl: 'src/grid-table/components/grid-editable-cell/grid-editable-cell.component.html',
        bindings: {
            /**
             * The row whose cell will be editing
             * @type {RenderIndexEntry}
             */
            row: '<',

            /**
             * The row whose cell will be editing
             * @type {number}
             */
            cellIndex: '<',

            /**
             * Callback to be when editing cell completed.
             * 1-) Press Enter
             * @type {Function}
             */
            onEditCellComplete: '&',

            /**
             * Callback to be executed on column change.
             * Provides the updated `columns` as argument
             * @type {Function}
             */
            onAbortEditingCell: '&'
        }
    });
})(window.angular);
